import { render, staticRenderFns } from "./ChannelsDistributionCard.vue?vue&type=template&id=20b08203&scoped=true"
import script from "./ChannelsDistributionCard.vue?vue&type=script&lang=js"
export * from "./ChannelsDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./ChannelsDistributionCard.vue?vue&type=style&index=0&id=20b08203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b08203",
  null
  
)

export default component.exports